import { PageState } from '../../../core/page/page.types';
import { ValidPropDroplistText } from '../../../core/components/validation/ValidInputDroplistText';
import { ValidPropRadioText } from '../../../core/components/validation/ValidInputRadioText';
import { ValidPropText } from '../../../core/components/validation/ValidInputText';
import { ValidPropRadioBool } from '../../../core/components/validation/ValidInputRadioBool';

// PAGE
export type PageInit = string; // return page title on init (its NEVER set again)
export type PageMode = '' | 'CREATE' | 'UPDATE';
export type PageStoreHook<TPageState extends PageState> = {
    state: TPageState;
    setEditStatus: (edit: boolean) => void;
    setPageMode: (mode: PageMode, id: string) => void;
    cancelEdit: () => void;
};

// EDIT FORM
export type ModelProp = 'Status' | 'Name' | 'Type';
export enum MedType {
    MANAGED = 'MM',
    MEDICAID = 'M',
}
export type StatusVal = '' | 'ACTIVE' | 'INACTIVE';
export type AdminGroupsModel = {
    Id: string;
    Name: ValidPropText;
    Type: ValidPropDroplistText;
    ObjectState: ValidPropRadioText;
    ContractFulfillment: ValidPropRadioBool;
    ContractType: ValidPropRadioText;
    Threshold: VmaxItem[];
};
export type EditStateGroup = {
    waiting: boolean;
    members: string[];
    memberAddDropList: ValidPropDroplistText;
    vmaxPopup: boolean;
    vmaxVendors: ValidPropText[];
};
export type EditStateHook = EditStateGroup & {
    setState: (draft: Partial<EditStateGroup>) => void;
};
export type EditModelGroupHook = {
    model: AdminGroupsModel;
    readOnlyModel: AdminGroupsModel;
    setPropText: (propName: string, val: string | number) => void;
    setStatus: (status: StatusVal) => void;
    submit: () => void;
    showVmax: boolean;
    saveAcct: () => void;
    memberAdd: () => void;
    memberChange: (id: string) => void;
    memberRemove: (id: string) => void;
    vmaxTogglePopup: () => void;
    vmaxThresholdUpdate: (items: VmaxItem[]) => void;
};

export type GroupsCreatePageState = PageState & {
    title: string;
    mode: string;
    id: string;
};

export type VmaxItem = {
    NDC: string;
    Vendor: string;
    TimePeriod: string;
    Value: number;
};

export enum GroupType {
    CE = 'CE',
    MAPPING = 'MAPPING',
    PHARMACY = 'PHARMACY',
    IDN = 'IDN',
}
